import React, { memo } from "react";
import styles from "../styles";

import { ListItem, withStyles, Checkbox, IconButton, Tooltip } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import ArrowRightIcon from "@material-ui/icons/ChevronRight";
import ArrowLeftIcon from "@material-ui/icons/ChevronLeft";
import Entity from "../../IntentClassification/Entity";

function setUpUtter(utterance) {
  let utter = [];
  let idx = 0;

  utterance.entities.forEach((item, index) => {
    utter.push(
      React.createElement(
        "span",
        { className: "unrecognized", key: index },
        utterance.user_input.slice(idx, item.start)
      )
    );
    let part = utterance.user_input.slice(item.start, item.end);
    let ent = item.role?item.entity + "(" + item.role + ")":item.entity;
    utter.push( <Entity key={part+index} text={part} entity={ent} /> );
    idx = item.end;
  });
  utter.push(React.createElement("span", { className: "unrecognized", key: idx + 1 }, utterance.user_input.slice(idx)));
  return utter;
}

function Utterance(props) {
  const {
    classes,
    id,
    utterance,
    clusterKey,
    handleRadioChange,
    handleUtteranceSwitch,
    selected,
    textSelectHandler
  } = props;
  const sel = props.selected == "1" ? true : false;
  const val = selected == true ? "0" : "1";
  var utter = setUpUtter(utterance);

  return (
    <ListItem key={utterance.id} elevation={1} className={classes.utteranceItem}>
      <Checkbox
        onChange={handleRadioChange.bind(this, clusterKey, id, val)}
        color="default"
        checked={sel}
        classes={{
          root: classes.disabledCheckbox,
          checked: classes.selectedCheckbox
        }}
      />
      <div>
        <Typography
          onMouseUp={() => textSelectHandler(id, clusterKey)}
          style={{ lineHeight: "21px" }}
          variant="body2"
          component="p"
        >
          {utter}
        </Typography>
        <Typography variant="subtitle1" component="p">
          {" "}
          Count: {utterance.count}{" "}
        </Typography>
      </div>
      <IconButton className={classes.utteranceButton} onClick={handleUtteranceSwitch.bind(this, clusterKey, id)}>
        {clusterKey != "Utterance Placeholder" ? (
          <Tooltip placement="top" title="Drop to placeholder">
            <ArrowRightIcon />
          </Tooltip>
        ) : (
          <Tooltip placement="top" title="Drop to cluster">
            <ArrowLeftIcon />
          </Tooltip>
        )}
      </IconButton>
    </ListItem>
  );
}

export default withStyles(styles)(
  memo(Utterance, (prevProps, nextProps) => {
    if (prevProps.selected !== nextProps.selected || prevProps.utterance.entities !== nextProps.utterance.entities) {
      console.log(prevProps);
      console.log(nextProps);

      return false;
    } else {
      return true;
    }
  })
);
